export default __webpack_public_path__ + "static/media/research-theory.4cb4f778.jpg";